/**
 * Referral Service
 * Handles all referral-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get user's referral information
 * @returns {Promise}
 */
export const getReferrals = async () => {
  return apiGet(API_CONFIG.endpoints.referrals);
};

